import React from 'react';
import ActivityPanel, { ActivityTabs } from '../../tabs/home/activity/ActivityPanel';
import Animation from '../../common/animation';

import './NotificationPanel.css';
import Store from '../../store/Store';
import { SHOW_NOTIFICATION_PANEL } from '../../store/Constants';
import t from '../../i18n/I18n';

type Props = {
  activities: string[],
  onClickEvent: Function,
  onClose: Function
};
export default class NotificationPanel extends React.Component<Props> {
  componentDidMount() {
    Store.put(SHOW_NOTIFICATION_PANEL, true);
  }

  componentWillUnmount() {
    Store.put(SHOW_NOTIFICATION_PANEL, false);
  }

  render() {
    const { activities, onClickEvent, onClose, hideNotification } = this.props;
    return (
      <Animation.Slide x={500}>
        <ActivityPanel
          ref="activityPanel"
          width="355px"
          hideNotification={hideNotification}
          emptyPrompt={t('EMPTY_NOTIFICATION')}
          loadingActivities={false}
          activities={activities}
          onClickEvent={(activity) => {
            onClickEvent(activity);
            onClose();
          }}
          action={[ActivityTabs.NOTIFICATIONS]}
          onClose={() => onClose()}
        />
      </Animation.Slide>
    );
  }
}
